import X9 from '@/components/X9.vue'
import Not404Found from '@/components/Not404Found.vue'
import { x9Data } from '@/data.js'

export const commonRoutes = [
	{
		path: '/',
		name: 'Home',
		component: X9,
		props: x9Data,
	},
	{
		path: '/main-variant-9',
		redirect: '/',
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'Not404Found',
		component: Not404Found,
		meta: { title: 'Страница не найдена' },
	},
]
